exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=number][data-v-2b62d7d3]::-webkit-inner-spin-button,input[type=number][data-v-2b62d7d3]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}", ""]);

// exports
